import { motion } from "framer-motion";
import { KineticWords } from "@/components/KineticText";

export const Manifesto = ({ chapters }) => {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative z-20 mx-auto max-w-6xl px-6 py-28 sm:px-10 lg:px-16 lg:py-40"
    >
      <div className="mb-20 flex items-center gap-4">
        <span className="h-px w-12 bg-matrix-green/50" />
        <span className="font-mono text-xs uppercase tracking-[0.35em] text-matrix-green">
          the_manifesto.log
        </span>
      </div>

      <div className="flex flex-col gap-24 lg:gap-40">
       {(Array.isArray(chapters) ? chapters : []).map((ch, i) => (
          <div
            key={ch.number}
            className={`grid grid-cols-1 gap-8 lg:grid-cols-12 lg:items-start ${
              i % 2 === 1 ? "" : ""
            }`}
            data-testid={`manifesto-chapter-${ch.number}`}
          >
            <div className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
              <motion.div
                initial={{ opacity: 0, x: i % 2 === 1 ? 40 : -40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-15% 0px" }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
              >
                <span className="block font-salt text-7xl leading-none text-matrix-orange sm:text-8xl lg:text-[9rem]" style={{ textShadow: "0 0 30px rgba(255,153,0,0.4)" }}>
                  {ch.number}
                </span>
                <span className="mt-4 block font-display text-2xl font-bold uppercase tracking-tight text-white sm:text-3xl">
                  {ch.title}
                </span>
              </motion.div>
            </div>

            <div className={`lg:col-span-7 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
              <p className="font-mono text-lg leading-relaxed text-white/75 sm:text-xl">
                <KineticWords text={ch.body} />
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
